<template>
  <vue-perfect-scrollbar
    class="inbox-content-scroll"
    :style="$store.getters.generalScrollStyle"
  >
    <div>
      <v-container grid-list-md>
        <archivos-listado
          v-if="listado.mostrar"
          v-bind="listado"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:verItem="ver"
          v-on:crearItem="crear"
          v-on:mostrarError="mostrarError"
        ></archivos-listado>
        <archivos-detalle
          v-if="detalle.mostrar"
          v-bind="detalle"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alCerrar="cerrarDetalle"
          v-on:mostrarError="mostrarError"
        ></archivos-detalle>
        <v-dialog
          v-model="formulario.mostrar"
          persistent
          transition="dialog-bottom-transition"
          max-width="600px"
          scrollable
        >
          <archivos-alta
            v-if="formulario.mostrar"
            v-bind="formulario"
            v-bind:permiso="permiso"
            v-bind:modelo-api="modeloApi"
            v-on:alGuardar="alGuardar"
            v-on:alCerrar="alCerrar"
          ></archivos-alta>
        </v-dialog>
      </v-container>
    </div>
  </vue-perfect-scrollbar>

</template>

<script>

import mixinAbm from '@/mixins/abm'
import Persona from '@/api/persona'
import ArchivosListado from '@/modules/administracion/usuarios/components/Archivos/ArchivosListado'
import ArchivosAlta from '@/modules/administracion/usuarios/components/Archivos/ArchivosAlta'
import ArchivosDetalle from '@/modules/administracion/usuarios/components/Archivos/ArchivosDetalle'
import _ from 'lodash'
export default {
  name: 'DetalleArchivos',
  mixins: [mixinAbm],
  components: {
    ArchivosListado,
    ArchivosAlta,
    ArchivosDetalle
  },
  data () {
    return {
      permiso: 'persona_archivos',
      modeloApi: Persona,
      listado: {
        referencia: 'personaArchivosListado'
      },
      detalle: {
        mostrar: false,
        archivoId: null
      }

    }
  },
  methods: {
    crear () {
      this.formulario = _.assign(this.formulario, {
        operacion: 'alta',
        titulo: 'Crear',
        item: {
          id: 0,
          tipo_archivo_id: null,
          descripcion: null,
          archivo: null
        },
        mostrar: true
      })
    },
    ver (item) {
      let vm = this

      vm.detalle.archivoId = item.id
      vm.listado.mostrar = false
      vm.detalle.mostrar = true
    },
    cerrarDetalle (item) {
      let vm = this
      if (item) { }
      vm.detalle.archivoId = null
      vm.detalle.mostrar = false
      vm.listado.mostrar = true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
